/**
 * EN QUE IDIOMA SE LE HABLA A UN CLIENTE EN UN PORTAL PUBLICO.
 *
 * Lissette, 2026-09-19: *«si el cliente habla español se le verá en español, o
 * cómo funcionaría?»*.
 *
 * El portal de documentos —donde el cliente sube su identificacion desde el
 * movil— estaba ENTERO en ingles. No es un detalle de estilo: es la pagina
 * donde se le pide algo a alguien y donde, si algo falla, hay que explicarselo.
 *
 * ── EL ORDEN, Y POR QUE ESE ─────────────────────────────────────────────────
 *
 *   1. `?lang=` en el enlace          la agente lo fuerza al mandarlo
 *   2. el idioma de su FICHA          lo que la agencia sabe de esa persona
 *   3. el idioma del navegador        el respaldo, cuando no hay ficha que leer
 *   4. ingles
 *
 * La ficha gana al navegador a proposito: es lo que la agencia APUNTO sobre
 * como hablarle a esa persona, y un telefono en ingles de alguien que habla
 * espanol es de lo mas comun. El `?lang=` gana a todo porque es una decision
 * consciente sobre ese envio concreto — el mismo criterio que `clientEmailLang`
 * en el servidor.
 *
 * ── LA LETRA PEQUEÑA, QUE HAY QUE DECIR ─────────────────────────────────────
 *
 * `preferredLanguage` viene con **ingles por defecto** en la base. Una ficha
 * que nadie toco dice "en", y por dentro NO se distingue de un "en" puesto a
 * proposito. Por eso la pagina lleva un boton ES/EN bien visible: el cliente
 * siempre tiene la ultima palabra sobre lo que lee. Si sale en el idioma que no
 * es, el arreglo de verdad es poner el idioma en su ficha.
 *
 * Sin dependencias: lo importan un componente y las pruebas.
 */

/** Acepta 'es', 'spanish', 'es-US'… igual que el servidor. */
export function normalizarIdioma(valor) {
  const s = String(valor || '').trim().toLowerCase();
  if (s.startsWith('es') || s.startsWith('spa')) return 'es';
  if (s.startsWith('en')) return 'en';
  return null;
}

/**
 * El idioma con el que ARRANCA el portal.
 *
 * `deLaFicha` llega del servidor (el token dice qué cliente es). `delEnlace` es
 * el `?lang=`. `delNavegador` es `navigator.language`.
 */
export function idiomaDelPortal({ delEnlace, deLaFicha, delNavegador } = {}) {
  return normalizarIdioma(delEnlace)
    || normalizarIdioma(deLaFicha)
    || normalizarIdioma(delNavegador)
    || 'en';
}

/** Lee el `?lang=` de una direccion. Null si no lo lleva. */
export function idiomaDelEnlace(busqueda) {
  try {
    return new URLSearchParams(busqueda || '').get('lang');
  } catch {
    return null;
  }
}
